import * as React from 'react'
import { translate } from 'react-translate'
import { includes } from 'lodash'

class MdHubSelect extends React.Component<MdHubSelectProps, MdHubSelectState> {

  constructor(props: any) {
    super(props)
    this.state = {
      hubs: [],
      focused: false,
      selectedHubs: [] as any,
      contractIds: this.props.baseContracts.map(c => c.id)
    }
  }

  public componentWillReceiveProps(nextProps) {
    if (this.props.baseContracts !== nextProps.baseContracts) {
      let hubs = this.initialHubs(nextProps.baseContracts)
      this.setState({
        hubs: hubs,
        selectedHubs: hubs as any
      })
    }
  }

  public componentWillMount() {
    let hubs = this.initialHubs(this.props.baseContracts)
    this.setState({
      hubs: hubs,
      selectedHubs: hubs as any
    })
  }

  public initialHubs(baseContracts) {
    const duplicateHubs = baseContracts.map(contract => contract.hub)

    let hubs = _.uniqBy(_.compact(duplicateHubs), (hub: any) => {
      return hub.id
    })
    return hubs
  }

  public isSelected(hub) {
    return includes(this.state.selectedHubs, hub)
  }

  public toggledSelectedHub(hub, e) {
    e.preventDefault()

    const selectedHubs = !includes(this.state.selectedHubs, hub)
      ? [...this.state.selectedHubs, hub]
      : this.state.selectedHubs.filter(h => h !== hub)

    this.setState({ selectedHubs })
    this.props.onHubChange(selectedHubs)
  }

  public toggledAllHubs(e) {
    e.preventDefault()

    const selectedHubs = (this.state.selectedHubs.length === this.state.hubs.length)
      ? []
      : this.state.hubs

    this.setState({
      selectedHubs: selectedHubs
    })
    this.props.onHubChange(selectedHubs)
  }

  public resetSelection(takeFocus) {
    let hubs = this.initialHubs(this.props.baseContracts)
    this.setState({
      focused: takeFocus,
      hubs: hubs,
      selectedHubs: hubs as any
    }, () => {
      this.props.onHubChange(hubs)
    })
  }

  public formatValue(account) {
    return account
  }

  private focus() {
    this.setState({
      focused: true
    })
  }

  private unfocus() {
    this.setState({
      focused: false
    })
  }

  public selectedHubsAsCodes() {
    let t = this.props.t
    const orderedHubs = _.orderBy(this.state.selectedHubs, ['name', 'ASC'])
    const hubText: string = orderedHubs.reduce((prev, hub) => {
      return prev + (prev !== '' ? ', ' : '') + t(hub.iata)
    }, '')
    return hubText
  }

  public render() {
    let hubsList = _.orderBy(this.state.hubs, ['name', 'ASC'])
    let t = this.props.t
    return (
      <div>
        <nav
          className={'hub-selector-wrapper hub-selector ' + (this.state.focused ? 'active' : '')}
          onMouseOver={() => this.focus()}
          onMouseLeave={() => this.unfocus()}>
          <div className='md-hubs-input'>
            <input
              onFocus={() => this.focus()}
              value={this.selectedHubsAsCodes()}
              type='text'
              placeholder={t('PLACEHOLDER')}
            />
            <div
              className='closeIcon'
              onClick={() => this.resetSelection(false)}>&nbsp;</div>
          </div>
          {(this.state.focused) ? (
            <div className='md-hub-list'>
              <ul>
                <li onMouseDown={(e) => this.toggledAllHubs(e)}>
                  <div className={'square-checkbox ' + ((this.state.hubs.length === this.state.selectedHubs.length) ? 'checked' : 'unchecked')}>
                    <span>&nbsp;{t('ALL_HUBS')}</span>
                  </div>
                </li>
                {hubsList.map((hub, id) => {
                  return <li key={id} onMouseDown={(e) => this.toggledSelectedHub(hub, e)}>
                    <div className={'square-checkbox ' + (this.isSelected(hub) ? 'checked' : 'unchecked')}>
                      <span>&nbsp;{t(hub.name)}</span>
                    </div>
                  </li>
                })}
              </ul>
            </div>
          ) : (null)}
        </nav>
      </div>
    )
  }
}

export default translate('MdHubSelect')(MdHubSelect)



// WEBPACK FOOTER //
// ./react/components/widgets/MdHubSelect.tsx